/**
 * 费率设置
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './SetArea.module.scss';
import http from '@/assets/api/http';
import { Col, Modal, Row, Typography, message } from 'antd';
import { XInputNum } from '@/components/xqxc_ui';

const { Title } = Typography;

const RateModal = ({
    closeModal,
    data: {
        opRatio = 0,
        companyInfoId = 0
    } = {}
}) => {

    const [rate, setRate] = useState(opRatio);
    const [loading, setLoading] = useState(false);

    const onAffirm = () => {
        setLoading(true);
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setCompanyRatio', { opRatio: rate, companyId: companyInfoId }, 'POST')
            .then(() => {
                message.success('费率设置操作成功');
                setLoading(false);
                closeModal(true);
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
    };

    return <Modal
        width={800}
        centered
        title='费用比例设置'
        visible={true}
        confirmLoading={loading}
        bodyStyle={{ paddingRight: '10px' }}
        onOk={onAffirm}
        onCancel={() => closeModal(false)}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        cancelText='取消'
        okText='提交'
    >
        <div className={styles.container}>
            <Row align='middle' gutter={[0, 16]}>
                <Col span={24}>
                    <Title level={5}>情形：配送订单归属运营公司1</Title>
                </Col>
                <Col span={12}>
                    <div className={styles.rateContent}>
                        <p className={styles.topText}>当归属运营公司1时，管理费比率</p>
                        <p className={styles.bottonText}>订单实付金额*平台服务费比率*运营公司管理费比率；</p>
                    </div>
                </Col>
                <Col span={12}>
                    <XInputNum
                        label='比率(%)'
                        placeholder='请输入比率值'
                        value={rate}
                        bindThis={setRate}
                        bindName='rate'
                        isRequired={true}
                        min={0.1}
                        max={80.0}
                        precision={1}
                    />
                </Col>
                <Col span={24}>
                    <div className={styles.rateTipText}>注：提交审核通过后生效</div>
                </Col>
            </Row>
        </div>
    </Modal>;
};

RateModal.propTypes = {
    closeModal: PropTypes.func,
    data: PropTypes.object
};
export default RateModal;
